import React from 'react';

import {
  NotebookPermission,
  type SelectedNotebookQuery,
} from '../../../../generated/graphql';
import {MarimoMode, useMarimoState} from '../../../PanelMarimo/store';
import {useMarimoSettingsStateContext} from './MarimoSettingsContextProvider';
import {RunCodeButton} from './RunCodeButton';
import {ViewNotebookButton} from './ViewNotebookButton';

export const ActiveNotebookBar = ({
  sourceNotebook,
}: {
  sourceNotebook: NonNullable<SelectedNotebookQuery['notebook']>;
}) => {
  const {panelId} = useMarimoSettingsStateContext();
  const {mode} = useMarimoState(state => state.getPanelState(panelId));
  const canEdit = sourceNotebook.viewerPermissions.includes(
    NotebookPermission.Edit
  );
  const canRun = sourceNotebook.viewerPermissions.includes(
    NotebookPermission.Run
  );
  const canView = sourceNotebook.viewerPermissions.includes(
    NotebookPermission.ViewStatic
  );
  return (
    <div className="flex gap-x-8">
      {mode === MarimoMode.STATIC && canRun && (
        <RunCodeButton notebookId={sourceNotebook.id} />
      )}
      {canView && (
        <ViewNotebookButton notebookId={sourceNotebook.id} canEdit={canEdit} />
      )}
    </div>
  );
};
